import { Pog } from "@CommonTypes/merchflow/pog/pog";
import { PlanogramItem } from "@CommonTypes/merchflow/pog/item";
import { BaseProduct } from "@CommonTypes/merchflow/pog/product";
import { PlanogramPegboardPlacement } from "@CommonTypes/merchflow/pog/pegboard";

export type PlanogramSelectedItem = PlanogramItem | PlanogramPegboardPlacement;

export const isPegboardPlacementSelection = (
  item: PlanogramSelectedItem,
): item is PlanogramPegboardPlacement => item instanceof PlanogramPegboardPlacement;

export const isPlanogramItemSelection = (item: PlanogramSelectedItem): item is PlanogramItem =>
  item instanceof PlanogramItem;

export const getSelectedProduct = (item: PlanogramSelectedItem): BaseProduct =>
  isPegboardPlacementSelection(item) ? item.pegProduct : item;

export const refreshSelectedItem = (
  pog: Pog,
  item: PlanogramSelectedItem,
): PlanogramSelectedItem | null => {
  return isPegboardPlacementSelection(item)
    ? pog.planogram.getPegboardPlacement(item.uniqueId)
    : pog.planogram.getItem(item.uniqueId);
};
